import { render, staticRenderFns } from "./ProjectesOblidats.vue?vue&type=template&id=195cebaa&"
import script from "./ProjectesOblidats.vue?vue&type=script&lang=js&"
export * from "./ProjectesOblidats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports